module.exports = __webpack_public_path__ + "img/1-ru.67746067.jpg";